var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('a',{attrs:{"href":"#"}},[_vm._v(" ")]),_vm._v(" "),_c('a',[_vm._v("© "+_vm._s(new Date().getFullYear())+" "+_vm._s(_vm.$t('footer.copyrights')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-671d7198","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/TheFooter.vue
// module id = 673
// module chunks = 5